export class StorageConfiguration {
  inputName: string;
  active: boolean;
  disableConvert4_20: boolean;
  transmitterType: string;
  capacity: number;
  geometricalCapacity: number;
  technicalCapacity: number;
  minTechnicalCapacity: number;
  productId: string;
  unit: string;
  rawThreshold: string;
  lowThreshold: number;
  lowLowThreshold: number;
  createAlarmOnEiu: boolean;
  thresholdsEdited: boolean;

  constructor(json?: any) {
    if (!json) {
      this.clear();
    } else {
      this.inputName = json.inputName;
      this.active = json.active || false;
      this.disableConvert4_20 = json.disableConvert4_20 || false;
      this.transmitterType = json.transmitterType;
      this.capacity = json.capacity;
      this.geometricalCapacity = json.geometricalCapacity;
      this.technicalCapacity = json.technicalCapacity;
      this.minTechnicalCapacity = json.minTechnicalCapacity;
      this.unit = json.unit || null;
      this.productId = json.productId || null;
      this.rawThreshold = json.rawThreshold || null;
      this.lowThreshold = json.lowThreshold;
      this.lowLowThreshold = json.lowLowThreshold;
      this.createAlarmOnEiu = json.createAlarmOnEiu;
      this.thresholdsEdited = json.thresholdsEdited;
    }
  }

  public clear(): void {
    this.active = false;
    this.disableConvert4_20 = false;
    this.transmitterType = null;
    this.capacity = null;
    this.geometricalCapacity = null;
    this.technicalCapacity = null;
    this.minTechnicalCapacity = null;
    this.unit = null;
    this.rawThreshold = null;
    this.lowThreshold = null;
    this.lowLowThreshold = null;
    this.createAlarmOnEiu = false;
    this.thresholdsEdited = false;
  }
}

export class StoragesConfiguration {
  E1: StorageConfiguration;
  E2: StorageConfiguration;
  E3: StorageConfiguration;
  E4: StorageConfiguration;
  TEMP: StorageConfiguration;

  constructor(json?: any) {
    if (!json)
      return;

    if (json.E1) {
      this.E1 = new StorageConfiguration(json.E1);
    } else {
      this.E1 = new StorageConfiguration();
      this.E1.inputName = "E1";
    }
    if (json.E2) {
      this.E2 = new StorageConfiguration(json.E2);
    } else {
      this.E2 = new StorageConfiguration();
      this.E2.inputName = "E2";
    }
    if (json.E3) {
      this.E3 = new StorageConfiguration(json.E3);
    } else {
      this.E3 = new StorageConfiguration();
      this.E3.inputName = "E3";
    }
    if (json.E4) {
      this.E4 = new StorageConfiguration(json.E4);
    } else {
      this.E4 = new StorageConfiguration();
      this.E4.inputName = "E4";
    }
    if (json.TEMP) {
      this.TEMP = new StorageConfiguration(json.TEMP);
    } else {
      this.TEMP = new StorageConfiguration();
      this.TEMP.inputName = "TEMP";
    }
  }
}

export class DeviceBaseConfiguration {
  callSchedule: string;
  callScheduleEdited: boolean;
  smsDailyLimit: Number;
  SMSC: string;
  phone: string;
  phone1: string;
  phone2: string;
  phone3: string;
  phone4: string;
  phone5: string;

  constructor(json?: any) {
    if (!json)
      return;

    this.callSchedule = json.callSchedule;
    this.callScheduleEdited = json.callScheduleEdited;
    this.smsDailyLimit = json.smsDailyLimit;
    this.SMSC = json.SMSC;
    this.phone = json.phone;
    this.phone1 = json.phone1;
    this.phone2 = json.phone2;
    this.phone3 = json.phone3;
    this.phone4 = json.phone4;
    this.phone5 = json.phone5;
  }
}

export class DeviceConfiguration {
  id: string;
  internalId: string;
  name: string;
  description: string;
  softwareVersion: string;
  model: string;
  endPoint: string;
  connector: string;
  configuration: DeviceBaseConfiguration;
  configurationVersion: Number;
  storages: StoragesConfiguration;
  lastValues: any;

  constructor(json?: any) {
    if (!json)
      return;

    this.id = json.id;
    this.internalId = json.internalId;
    this.name = json.name;
    this.description = json.description;
    this.endPoint = json.endPoint;
    this.softwareVersion = json.softwareVersion;
    this.model = json.model;
    this.connector = json.connector;
    this.configuration = json.configuration ? new DeviceBaseConfiguration(json.configuration) : null;
    this.configurationVersion = json.configurationVersion;
    this.storages = json.storages ? new StoragesConfiguration(json.storages) : null;
    this.lastValues = json.lastValues;
  }
}

